var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "23px",
    viewBox: "0 0 26 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "menu_home") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.000000, -3.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.000000, 3.000000)",
    fill: "#5A5F65",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3622314,0.227642528 L13.4692405,0.282344287 L13.5701077,0.352662038 L24.8673173,9.70604458 C25.188337,10.0282962 25.2474644,10.5427402 24.9834176,10.8740355 C24.6773296,11.2427342 24.1602854,11.2826596 23.8081522,10.9998089 L22.2896268,9.70710718 L22.2896268,21.894756 C22.2896268,22.3532623 21.9017327,22.742645 21.4444058,22.742645 L15.5608786,22.742645 C15.1035517,22.742645 14.7156576,22.3532623 14.7156576,21.894756 L14.7156576,16.1913614 L11.2711438,16.1913614 L11.2711438,21.894756 C11.2711438,22.3608418 10.930827,22.742645 10.4793884,22.742645 L4.59480921,22.742645 C4.10043301,22.742645 3.74958821,22.3708925 3.74958821,21.894756 L3.74958821,9.70692496 L2.21725715,11.0102499 C1.81098124,11.282146 1.29957675,11.2426567 1.06494013,10.8840852 C0.733679949,10.5515538 0.794689897,10.0207944 1.18224427,9.69658648 L6.78486519,5.04165984 L12.471108,0.351026834 C12.7289193,0.14399095 13.0700628,0.102583773 13.3622314,0.227642528 Z M12.9920797,2.05979065 L5.3866847,8.37848068 L5.3866847,21.046867 L9.63342282,21.046867 L9.63342282,15.3969986 C9.63342282,14.9013225 10.003777,14.5491096 10.4786438,14.5491096 L10.4786438,14.5491096 L15.560038,14.5491096 C16.0173649,14.5491096 16.405259,14.9384923 16.405259,15.3969986 L16.405259,15.3969986 L16.405259,21.046867 L20.5984354,21.046867 L20.5984354,8.37927889 L12.9920797,2.05979065 Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.f8228434.svg";
export { ForwardRef as ReactComponent };